<script setup>
import { useHead } from "@vueuse/head";
import RealtimeKujibikiCta from "@/components/molecules/RealtimeKujibikiCta.vue";

// SEO構造化データ（Article スキーマ）
const articleSchema = {
  "@context": "https://schema.org",
  "@type": "Article",
  headline:
    "【VTuberインタビュー】リアルタイムくじ引きを体験したうぎちゃみパイセンさんに聞く！配信企画の裏側と感想",
  description:
    "実際にリアルタイムくじ引きを実施したVTuber・うぎちゃみパイセンさんへのインタビュー。参加のきっかけや配信の反応、従来のグッズ販売との違いなど本音で語っていただきました。",
  datePublished: "2026-01-20",
  dateModified: "2026-01-20",
  author: {
    "@type": "Organization",
    name: "SukiSukiらいぶすてーしょん",
  },
  publisher: {
    "@type": "Organization",
    name: "SukiSukiらいぶすてーしょん",
  },
  image: "/img/airticlepic/ugichamipaisen_intervie_top.webp",
};

// メタ情報と構造化データを設定
useHead({
  title:
    "【VTuberインタビュー】リアルタイムくじ引きを体験したうぎちゃみパイセンさんに聞く！配信企画の裏側と感想 | SukiSukiらいぶすてーしょん",
  meta: [
    {
      name: "description",
      content:
        "実際にリアルタイムくじ引きを実施したVTuber・うぎちゃみパイセンさんへのインタビュー。参加のきっかけや配信の反応、従来のグッズ販売との違いなど本音で語っていただきました。",
    },
    {
      property: "og:title",
      content:
        "【VTuberインタビュー】リアルタイムくじ引きを体験したうぎちゃみパイセンさんに聞く！配信企画の裏側と感想 | SukiSukiらいぶすてーしょん",
    },
    {
      property: "og:description",
      content:
        "実際にリアルタイムくじ引きを実施したVTuber・うぎちゃみパイセンさんへのインタビュー。参加のきっかけや配信の反応、従来のグッズ販売との違いなど本音で語っていただきました。",
    },
    {
      property: "og:type",
      content: "website",
    },
    {
      property: "og:image",
      content: "https://sukisuki.live/img/airticlepic/ugichamipaisen_intervie_top.webp",
    },
  ],
  script: [
    {
      type: "application/ld+json",
      children: JSON.stringify(articleSchema),
    },
  ],
});
</script>

<template>
  <v-app>
    <!-- ヒーローセクション -->
    <figure class="hero-section">
      <img
        src="/img/airticlepic/ugichamipaisen_intervie_top.webp"
        alt="うぎちゃみパイセンさんインタビュー記事のヒーロー画像"
      />
    </figure>

    <!-- パンくずナビゲーション -->
    <nav aria-label="パンくずリスト" class="breadcrumb-section">
      <v-container>
        <ol class="breadcrumb">
          <li><a href="/academy">TOP</a></li>
          <li>リアルタイムくじ引きインタビュー</li>
        </ol>
      </v-container>
    </nav>

    <!-- メインコンテンツ -->
    <main>
      <article class="article-content">
        <v-container>
          <!-- 記事タイトル -->
          <div class="article-title-box">
            <h1>
              【VTuberインタビュー】リアルタイムくじ引きを体験したうぎちゃみパイセンさんに聞く！配信企画の裏側と感想
            </h1>
          </div>

          <!-- 更新日 -->
          <div class="update-date-box">
            <time datetime="2026-01-20">更新日:2026年1月20日</time>
          </div>

          <!-- イントロダクション -->
          <div class="intro-box">
            <p>
              実際にリアルタイムくじ引きを実施したVTuber・うぎちゃみパイセンさんへのインタビュー。参加のきっかけや配信の反応、従来のグッズ販売との違いなど本音で語っていただきました。
            </p>
          </div>

          <section class="learn-section">
            <h2 class="learn-title">うぎちゃみパイセンさんインタビュー</h2>
            <div class="learn-content">
              <div class="interview-intro">
                <p>今回は、実際にリアルタイムくじ引きを実施された<span class="bold-text">うぎちゃみパイセン</span>さんにお話を伺いました。配信中の盛り上がりや初見リスナーの参加など、従来のグッズ販売とは異なる反応が生まれ、ファンと一緒に楽しむ体験型グッズ販売として、新しい可能性を感じられるイベントとなりました。</p>
              </div>

              <div class="interview-question">
                <div class="chat-row chat-row--question">
                  <p class="question-label">簡単に自己紹介をお願いします。</p>
                  <img
                    class="chat-avatar chat-avatar--question"
                    src="/img/icon_logo.webp"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="chat-row chat-row--answer">
                  <img
                    class="chat-avatar chat-avatar--answer"
                    src="/img/icon_ugi.webp"
                    alt=""
                    aria-hidden="true"
                  />
                  <p class="answer-text">みんなやっほ⤴︎⤴︎🌺🌈💕けもギャル系VTuberうぎちゃみパイセンだよん！個人VTuber唯一無二の黒ギャルマンバ！普段はYouTubeにて企画や雑談配信メインで活動してるんご🫰🏽🌺
                  目標のチャンネル登録10万人に向けて爆アゲ中⭐️
                  ぜひ遊びに来てねん✨😎🌈💝</p>
                </div>
              </div>

              <div class="interview-profile-links">
                <p class="profile-links-title">うぎちゃみパイセン 公式リンク</p>
                <ul class="profile-links-list">
                  <li>・X（旧Twitter）：<a href="https://x.com/GAL_Ugi" target="_blank" rel="noopener noreferrer">https://x.com/GAL_Ugi</a></li>
                  <li>・YouTube：<a href="https://www.youtube.com/channel/UCvoHbG-CwEZ8vdakzQeCMAw" target="_blank" rel="noopener noreferrer">https://www.youtube.com/channel/UCvoHbG-CwEZ8vdakzQeCMAw</a></li>
                </ul>
              </div>

              <div class="interview-question">
                <div class="chat-row chat-row--question">
                  <p class="question-label">今回、SukiSukiらいぶすてーしょんの「リアルタイムくじ引き」に参加しようと思ったきっかけを教えてください。</p>
                  <img
                    class="chat-avatar chat-avatar--question"
                    src="/img/icon_logo.webp"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="chat-row chat-row--answer">
                  <img
                    class="chat-avatar chat-avatar--answer"
                    src="/img/icon_ugi.webp"
                    alt=""
                    aria-hidden="true"
                  />
                  <p class="answer-text">配信中にくじ引きが出来るという事で
                  全国どこに住んでいても関係無く楽しめるイベントだと思ったからです！
                  あと自分では作成がなかなか出来ない賞品もとても魅力的でした！</p>
                </div>
              </div>

              <div class="interview-question">
                <div class="chat-row chat-row--question">
                  <p class="question-label">参加前は、リアルタイムくじ引きに対して、どのような印象をお持ちでしたか？</p>
                  <img
                    class="chat-avatar chat-avatar--question"
                    src="/img/icon_logo.webp"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="chat-row chat-row--answer">
                  <img
                    class="chat-avatar chat-avatar--answer"
                    src="/img/icon_ugi.webp"
                    alt=""
                    aria-hidden="true"
                  />
                  <p class="answer-text">自分も含めくじ引きはわくわくするものなので純粋に楽しみでした！
                  ただ、配信が3回必須だったのですが
                  リピートして下さるリスナーさん居るのかな？と
                  不安も少しありました。</p>
                </div>
              </div>

              <div class="interview-question">
                <div class="chat-row chat-row--question">
                  <p class="question-label">これまでのグッズ販売は、どのような形で行っていましたか？</p>
                  <img
                    class="chat-avatar chat-avatar--question"
                    src="/img/icon_logo.webp"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="chat-row chat-row--answer">
                  <img
                    class="chat-avatar chat-avatar--answer"
                    src="/img/icon_ugi.webp"
                    alt=""
                    aria-hidden="true"
                  />
                  <p class="answer-text">基本的にはBOOTHにて周年グッズやBirthdayグッズを
                  展開したり、頂いた案件の際にコラボグッズを販売しておりました。</p>
                </div>
              </div>

              <div class="interview-question">
                <div class="chat-row chat-row--question">
                  <p class="question-label">実際にリアルタイムくじ引きを実施してみて、最初に感じたことを教えてください。</p>
                  <img
                    class="chat-avatar chat-avatar--question"
                    src="/img/icon_logo.webp"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="chat-row chat-row--answer">
                  <img
                    class="chat-avatar chat-avatar--answer"
                    src="/img/icon_ugi.webp"
                    alt=""
                    aria-hidden="true"
                  />
                  <p class="answer-text">思ってたよりも皆さんくじ引き引いてくださるなー！
                  と嬉しい気持ちでいっぱいでした。</p>
                </div>
              </div>

              <div class="interview-question">
                <div class="chat-row chat-row--question">
                  <p class="question-label">配信中の雰囲気や、リスナーさんの反応で印象的だったことはありますか？</p>
                  <img
                    class="chat-avatar chat-avatar--question"
                    src="/img/icon_logo.webp"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="chat-row chat-row--answer">
                  <img
                    class="chat-avatar chat-avatar--answer"
                    src="/img/icon_ugi.webp"
                    alt=""
                    aria-hidden="true"
                  />
                  <p class="answer-text">やはり皆さん個々に欲しいグッズがあるので
                  白熱してましたww</p>
                </div>
              </div>

              <div class="archive-section">
                <h3 class="archive-title">🎥 実際の配信アーカイブはこちら</h3>
                <p class="archive-description">実際のリアルタイムくじ引き配信の様子は、以下のアーカイブからご覧いただけます。<br>
                配信中の盛り上がりや、スーパレアが出た瞬間の雰囲気をぜひご確認ください。</p>
                <a href="/archiveex?event_id=ugichamipaisen-1&live_id=dLpZPbRHmwpXicsdtUHb" class="archive-link">▶ アーカイブ配信を視聴する</a>
              </div>

              <div class="interview-question">
                <div class="chat-row chat-row--question">
                  <p class="question-label">「これは想像と違った」「意外だった」と感じたポイントはありましたか？</p>
                  <img
                    class="chat-avatar chat-avatar--question"
                    src="/img/icon_logo.webp"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="chat-row chat-row--answer">
                  <img
                    class="chat-avatar chat-avatar--answer"
                    src="/img/icon_ugi.webp"
                    alt=""
                    aria-hidden="true"
                  />
                  <p class="answer-text">いつも応援して下さる皆様は勿論なのですが
                  初見さんがたくさん引いてくださったのが
                  とても驚きました！(嬉しかったです！)</p>
                </div>
              </div>

              <div class="interview-question">
                <div class="chat-row chat-row--question">
                  <p class="question-label">これまでの従来のグッズ販売と比べて、違いを感じた点はどこですか？</p>
                  <img
                    class="chat-avatar chat-avatar--question"
                    src="/img/icon_logo.webp"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="chat-row chat-row--answer">
                  <img
                    class="chat-avatar chat-avatar--answer"
                    src="/img/icon_ugi.webp"
                    alt=""
                    aria-hidden="true"
                  />
                  <p class="answer-text">リスナー様から何が当たるか分からないわくわくさをリアルタイムで感じれました！</p>
                </div>
              </div>

              <div class="interview-question">
                <div class="chat-row chat-row--question">
                  <p class="question-label">リアルタイムくじ引きを通して、リスナーさんとの距離感に変化はありましたか？</p>
                  <img
                    class="chat-avatar chat-avatar--question"
                    src="/img/icon_logo.webp"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="chat-row chat-row--answer">
                  <img
                    class="chat-avatar chat-avatar--answer"
                    src="/img/icon_ugi.webp"
                    alt=""
                    aria-hidden="true"
                  />
                  <p class="answer-text">距離感は特に変化はないですが
                  楽しかったねー！と今でもお話してくれます！</p>
                </div>
              </div>

              <div class="interview-question">
                <div class="chat-row chat-row--question">
                  <p class="question-label">ファンの方が特に楽しんでいると感じた瞬間は、どんな場面でしたか？</p>
                  <img
                    class="chat-avatar chat-avatar--question"
                    src="/img/icon_logo.webp"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="chat-row chat-row--answer">
                  <img
                    class="chat-avatar chat-avatar--answer"
                    src="/img/icon_ugi.webp"
                    alt=""
                    aria-hidden="true"
                  />
                  <p class="answer-text">スーパレアが出た時ですね！</p>
                </div>
              </div>

              <div class="interview-question">
                <div class="chat-row chat-row--question">
                  <p class="question-label">参加にあたって、準備で大変だったことはありましたか？</p>
                  <img
                    class="chat-avatar chat-avatar--question"
                    src="/img/icon_logo.webp"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="chat-row chat-row--answer">
                  <img
                    class="chat-avatar chat-avatar--answer"
                    src="/img/icon_ugi.webp"
                    alt=""
                    aria-hidden="true"
                  />
                  <p class="answer-text">配信先がYouTubeでは無かったので
                  「じゃあいいや…」ってならないように
                  告知頑張りました！</p>
                </div>
              </div>

              <div class="interview-question">
                <div class="chat-row chat-row--question">
                  <p class="question-label">SukiSukiらいぶすてーしょん側のサポートについて、どのように感じましたか？</p>
                  <img
                    class="chat-avatar chat-avatar--question"
                    src="/img/icon_logo.webp"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="chat-row chat-row--answer">
                  <img
                    class="chat-avatar chat-avatar--answer"
                    src="/img/icon_ugi.webp"
                    alt=""
                    aria-hidden="true"
                  />
                  <p class="answer-text">とても丁寧、親切にサポート頂き感謝しかございません！
                  配信中に急に出てしまったリスナー様の質問に
                  リアルタイムで回答を連絡頂けた時はとても感動しました！</p>
                </div>
              </div>

              <div class="interview-question">
                <div class="chat-row chat-row--question">
                  <p class="question-label">「これなら初めてでもやりやすい」と感じた点があれば教えてください。</p>
                  <img
                    class="chat-avatar chat-avatar--question"
                    src="/img/icon_logo.webp"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="chat-row chat-row--answer">
                  <img
                    class="chat-avatar chat-avatar--answer"
                    src="/img/icon_ugi.webp"
                    alt=""
                    aria-hidden="true"
                  />
                  <p class="answer-text">アカウントを作るのが簡単なのと
                  お支払い方法が豊富なところ
                  シンプルな操作が初めての方も
                  やりやすかったと思います！</p>
                </div>
              </div>

              <div class="interview-question">
                <div class="chat-row chat-row--question">
                  <p class="question-label">やってみて「参加してよかった」と感じたポイントはどこですか？</p>
                  <img
                    class="chat-avatar chat-avatar--question"
                    src="/img/icon_logo.webp"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="chat-row chat-row--answer">
                  <img
                    class="chat-avatar chat-avatar--answer"
                    src="/img/icon_ugi.webp"
                    alt=""
                    aria-hidden="true"
                  />
                  <p class="answer-text">やはり、<br>
                  ・どこに住んでいても楽しめる<br>
                  ・いつもと違う特別な賞品<br>
                  かなと思います！</p>
                </div>
              </div>

              <div class="interview-question">
                <div class="chat-row chat-row--question">
                  <p class="question-label">もし次にやるとしたら、やってみたい企画やグッズはありますか？</p>
                  <img
                    class="chat-avatar chat-avatar--question"
                    src="/img/icon_logo.webp"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="chat-row chat-row--answer">
                  <img
                    class="chat-avatar chat-avatar--answer"
                    src="/img/icon_ugi.webp"
                    alt=""
                    aria-hidden="true"
                  />
                  <p class="answer-text">ぬいぐるみ系の賞品でリアルタイムくじ引き
                  やってみたいです！(尻尾のキーホルダーや、ぬいキー、ぬいぐるみなど)</p>
                </div>
              </div>

              <div class="interview-question">
                <div class="chat-row chat-row--question">
                  <p class="question-label">リアルタイムくじ引きに興味はあるけど、迷っているVTuberさんに一言お願いします。</p>
                  <img
                    class="chat-avatar chat-avatar--question"
                    src="/img/icon_logo.webp"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="chat-row chat-row--answer">
                  <img
                    class="chat-avatar chat-avatar--answer"
                    src="/img/icon_ugi.webp"
                    alt=""
                    aria-hidden="true"
                  />
                  <p class="answer-text">とても親切にサポートして頂けますし
                  作成いただけるデザインも可愛いので
                  安心して参加できると感じております！
                  是非やりたいけどなー…で迷っている方は参加する一択！です！</p>
                </div>
              </div>

              <div class="interview-question">
                <div class="chat-row chat-row--question">
                  <p class="question-label">どんなタイプのVTuberさんに、この企画は向いていると思いますか？</p>
                  <img
                    class="chat-avatar chat-avatar--question"
                    src="/img/icon_logo.webp"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="chat-row chat-row--answer">
                  <img
                    class="chat-avatar chat-avatar--answer"
                    src="/img/icon_ugi.webp"
                    alt=""
                    aria-hidden="true"
                  />
                  <p class="answer-text">全てのタイプに向いていると思います！
                  ただ、グッズに興味ない
                  ランダムが苦手なリスナーさんが多いと
                  難しいかも…？</p>
                </div>
              </div>

              <div class="interview-question">
                <div class="chat-row chat-row--question">
                  <p class="question-label">今回のリアルタイムくじ引きを、全体として振り返ると、どんな企画でしたか？</p>
                  <img
                    class="chat-avatar chat-avatar--question"
                    src="/img/icon_logo.webp"
                    alt=""
                    aria-hidden="true"
                  />
                </div>
                <div class="chat-row chat-row--answer">
                  <img
                    class="chat-avatar chat-avatar--answer"
                    src="/img/icon_ugi.webp"
                    alt=""
                    aria-hidden="true"
                  />
                  <p class="answer-text">本当に参加して良かったと思える素敵なイベントとなりました！期間中リスナーさんもとても楽しそうで大満足！！本当にありがとうございました！✨</p>
                </div>
              </div>
            </div>
          </section>

          <!-- CTA ボタン -->
          <RealtimeKujibikiCta article-id="academy-article-realtime-3" class="mb-10" />
        </v-container>
      </article>
    </main>
  </v-app>
</template>

<style scoped>
/* ヒーローセクション */
.hero-section {
  padding: 20px;
  width: 100%;
}

.hero-section img {
  width: 100%;
  height: auto;
  display: block;
}

/* パンくず */
.breadcrumb-section {
  background-color: white;
}

.breadcrumb {
  color: #666;
  font-size: 14px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 8px;
  text-align: left;
  display: flex;
  list-style: none;
  margin: 0;
  gap: 8px;
}

.breadcrumb li {
  display: inline-block;
}

.breadcrumb li:not(:last-child)::after {
  content: ">";
  margin-left: 8px;
}

.breadcrumb a {
  color: #666;
  text-decoration: none;
}

.breadcrumb a:hover {
  text-decoration: underline;
}

/* メインコンテンツ */
::v-deep(.v-container) {
  text-align: left;
  padding: 0 !important;
}

.article-content {
  text-align: left;
}

.article-content h2,
.article-content h3 {
  text-align: left;
}

.article-title-box {
  margin-bottom: 5px;
}

.article-title-box h1,
.article-title-box h2 {
  color: #333;
  font-size: 18px;
  margin: 0;
  font-weight: bold;
  text-align: left;
  padding-left: 20px;
  padding-right: 20px;
  line-height: 1.6;
}

.update-date-box {
  padding: 10px 20px;
  margin-bottom: 10px;
}

.update-date-box p,
.update-date-box time {
  color: #333;
  margin: 0;
  font-size: 14px;
  text-align: left;
}

.intro-box {
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 30px;
  margin-left: 20px;
  margin-right: 20px;
  font-size: 14px;
}

.intro-box p {
  color: #333;
  margin: 0;
  line-height: 1.6;
  text-align: left;
}

.learn-section {
  margin: 30px 0;
}

.learn-title {
  color: #333;
  font-size: 20px;
  font-weight: bold;
  margin: 0 0 20px 20px;
  text-align: left;
  background-color: #ffe0e0;
  padding: 15px 0 15px 20px;
  position: relative;
  line-height: 1.6;
}

.learn-title::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 8px;
  height: 100%;
  background-color: #982da6;
}

.learn-content {
  margin-left: 20px;
  text-align: left;
}

.interview-profile-links {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  margin: 24px 20px 24px 0;
  border-left: 4px solid #982da6;
}

.interview-profile-links .profile-links-title {
  font-weight: bold;
  color: #333;
  margin: 0 0 12px 0;
  font-size: 16px;
}

.interview-profile-links .profile-links-list {
  list-style: none;
  padding: 0;
  margin: 0 0 16px 0;
  font-size: 14px;
  color: #333;
}

.interview-profile-links .profile-links-list li {
  margin-bottom: 6px;
}

.interview-profile-links .profile-links-list a {
  color: #1976d2;
  text-decoration: none;
}

.interview-profile-links .profile-links-list a:hover {
  text-decoration: underline;
}

.interview-profile-links .profile-links-catch {
  color: #333;
  font-size: 14px;
  margin: 0;
  line-height: 1.6;
}

.learn-content p {
  color: #333;
  line-height: 1.6;
  margin: 0 20px 15px 0;
  text-align: left;
  font-size: 16px;
}

.bold-text {
  font-weight: bold;
}

/* インタビューセクション */
.interview-intro {
  background-color: #f9f9f9;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 25px;
}

.chat-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
}

.chat-row--question {
  justify-content: flex-end; /* 右：質問者 */
}

.chat-row--answer {
  justify-content: flex-start; /* 左：うぎちゃみパイセン */
}

.chat-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  flex: 0 0 64px;
  border: 3px solid #ffffff;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
  object-fit: cover;
  background-color: #ffffff;
}

.interview-intro p {
  margin: 0 !important;
  font-size: 16px;
}

.interview-question {
  margin-bottom: 50px;
  padding: 0;
  background-color: transparent;
  border-left: none;
  border-radius: 0;
  box-shadow: none;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.interview-question::before {
  content: none;
}

.interview-question > * {
  position: relative;
  z-index: 1;
}

.question-label {
  font-weight: 400;
  color: #982da6;
  margin-bottom: 12px !important;
  font-size: 16px !important;
  line-height: 1.6 !important;
  padding: 12px 16px;
  position: relative;
  background-color: #ffffff;
  border: 2px solid #000000;
  border-radius: 18px;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.06);
  display: inline-block;
  max-width: min(720px, 78%);
  align-self: auto;
  text-align: left;
}

.question-label::before {
  content: none;
}

.question-label::after {
  content: "";
  position: absolute;
  right: -10px;
  top: 18px;
  width: 18px;
  height: 18px;
  background-color: #ffffff;
  transform: rotate(45deg);
  border-right: 2px solid #000000;
  border-top: 2px solid #000000;
}

.answer-text {
  color: #333;
  line-height: 1.8 !important;
  margin: 0 !important;
  font-size: 15px !important;
  white-space: pre-line;
  padding: 12px 16px;
  position: relative;
  background-color: #fff7fb;
  border-radius: 18px;
  border: 2px solid #000000;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.06);
  display: inline-block;
  max-width: min(720px, 78%);
  align-self: auto;
  text-align: left;
}

.answer-text::before {
  content: none;
}

.answer-text::after {
  content: "";
  position: absolute;
  left: -10px;
  top: 18px;
  width: 18px;
  height: 18px;
  background-color: #fff7fb;
  transform: rotate(45deg);
  border-left: 2px solid #000000;
  border-bottom: 2px solid #000000;
}

/* アーカイブセクション */
.archive-section {
  margin: 40px 0;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 12px;
  text-align: left;
}

.archive-title {
  color: #333;
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 12px 0;
  line-height: 1.6;
}

.archive-description {
  color: #333;
  font-size: 15px;
  line-height: 1.8;
  margin: 0 0 16px 0;
}

.archive-link {
  display: inline-block;
  color: #982da6;
  font-size: 16px;
  font-weight: bold;
  text-decoration: none;
  padding: 10px 20px;
  background-color: #ffffff;
  border: 2px solid #982da6;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.archive-link:hover {
  background-color: #982da6;
  color: #ffffff;
}

@media (min-width: 750px) {
  .hero-section {
    padding: 0 25%;
  }

  .hero-section img {
    width: 100%;
    height: auto;
    display: block;
  }
  .breadcrumb {
    padding: 10px 25%;
  }
  .v-container {
    max-width: 5000px !important;
  }
  .article-title-box {
    padding: 0 25%;
  }
  .article-title-box h1,
  .article-title-box h2 {
    font-size: 20px;
    padding: 0;
    line-height: 1.6;
  }
  .update-date-box {
    padding: 10px 25%;
  }
  .update-date-box p,
  .update-date-box time {
    padding: 0;
  }
  .intro-box {
    padding: 10px;
  }
  .intro-box p {
    font-size: 16px;
    line-height: 1.6;
  }
  .intro-box {
    margin-left: 25%;
    margin-right: 25%;
  }
  .learn-title {
    margin-left: 25%;
    margin-right: 25%;
  }
  .learn-content {
    margin-left: 25%;
    margin-right: 25%;
  }
  .learn-content p {
    margin-left: 0;
    margin-right: 0;
  }
}

@media (max-width: 520px) {
  .learn-content {
    margin-right: 20px;
  }
  .chat-avatar {
    width: 44px;
    height: 44px;
    flex-basis: 44px;
  }
  .question-label,
  .answer-text {
    max-width: 84%;
  }
}
</style>
